import { mkTrackAttrs } from '@/analytics/track';

const PREFIX = `msg_bar` as const;

// Send Button
export const mkSendBtnTrackAttrs = (props: { message: string }) =>
  mkTrackAttrs(`${PREFIX}__send_btn`, props);

// Text Box
export const mkTextBoxTrackAttrs = (props: { message: string }) =>
  mkTrackAttrs(`${PREFIX}__text_box`, props);
